// Shared layout + card styles for the Phase 1A dashboard completion state.
// Each helper component (DashboardHero, OnboardingChecklist, etc.) imports
// from this module to keep visual language consistent and to avoid four
// near-identical card style files.

import type { CSSProperties } from "react";

export const sectionStack: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-6)",
};

export const sectionTitle: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
  marginBottom: "var(--sz-space-3)",
};

export const card: CSSProperties = {
  background: "var(--sz-bg-surface)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-lg)",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-3)",
};

export const cardEyebrow: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
};

export const cardTitle: CSSProperties = {
  fontFamily: "var(--sz-font-head)",
  fontSize: "20px",
  fontWeight: 700,
  color: "var(--sz-text-primary)",
  lineHeight: 1.2,
};

export const cardBody: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-md)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.6,
};

export const cardBodySm: CSSProperties = {
  ...cardBody,
  fontSize: "var(--sz-body-sm)",
};

export const grid2: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
  gap: "var(--sz-space-5)",
};

export const accentBorder: CSSProperties = {
  borderTop: "2px solid var(--sz-amber)",
};

export const successBorder: CSSProperties = {
  borderTop: "2px solid var(--sz-success)",
};

export const warningBorder: CSSProperties = {
  borderTop: "2px solid var(--sz-warning)",
};

export const link: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-amber-text)",
  letterSpacing: "0.5px",
  borderBottom: "1px solid var(--sz-amber-dim)",
  paddingBottom: "1px",
  alignSelf: "flex-start",
};

export const inlineKey: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "1.5px",
  color: "var(--sz-text-muted)",
  textTransform: "uppercase",
};
